import { theme as wllTheme } from '@/core/App/theme';
import { ThemeProvider } from 'react-admin';
import Popup from './Popup';

type ReloadPromptProps = {
  onRefresh?: () => void;
  onCancel?: () => void;
};
export const ReloadPrompt = ({ onRefresh, onCancel }: ReloadPromptProps) => {
  return (
    <ThemeProvider theme={wllTheme}>
      <Popup
        button="Refresh"
        action={onRefresh}
        message={'New version of White Label Loyalty is available.'}
        visible={true}
        toggleVisibility={onCancel}
      />
    </ThemeProvider>
  );
};
